import { Vue, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { LeftText } from "../components/LeftText/index";
import { RightText } from "../components/RightText/index";
import { ImgText } from "../components/ImgText/index";
import { ChoiceText } from "../components/ChoiceText/index";
import { ExamText } from "../components/ExamText/index";
import { VideoItem } from "@/pages/studyCommon/VideoItem";
// import { CodeCompareItem } from "../components/CodeCompareItem";
import { CodeCompareItem } from "@/pages/studyCommon/code/CodeCompareItem";
import { CodeCopyItem } from "../components/CodeCopyItem";
// import { CodeCopyItem } from "@/pages/studyCommon/code/CodeCopyItem";
import { CodeHintItem } from "../components/CodeHintItem";
import { ImgTextRight } from "../components/ImgTextRight/index";
import { ProgramItem } from "../components/programItem";
import { AiVideo } from "../components/AiVideo";
import { LikeOrNot } from "../components/LikeOrNot";
// import { LikeOrNot } from "@/pages/studyCommon/likeOrNot";

@Component({
    name: "AiMain",
    components: {
        LeftText,
        RightText,
        ImgText,
        ChoiceText,
        VideoItem,
        CodeCompareItem,
        ExamText,
        CodeCopyItem,
        CodeHintItem,
        ImgTextRight,
        ProgramItem,
        AiVideo,
        LikeOrNot
    }
})
export default class AiMain extends Vue {
    private catalogs: any = [];
    private courseLabel: string = "PRIMARY";
    private allDataList: any = {};
    private courseListData: any = {};
    private section: any = {};
    private starValue: any = null;
    private studentImg: string =
        "https://asset.greedyai.com//new/aijiaoai/actorimg/%E5%A4%8F%E6%B2%AB.png";
    private actorImg: string = "";
    private userAvatar: string = "";

    @Prop() readonly sections: any;
    @Watch("sections") getSection(val) {
        this.section = val;
    }
    @Prop() readonly allData: any;
    @Watch("allData") getallDataList(val) {
        this.allDataList = val;
        this.allDataList.forEach(item => {
            let actorImg = item.actor ? item.actor.img : "";
            this.$set(item, "actorImg", actorImg);
        });
    }
    @Prop() readonly courseList: any;
    @Watch("courseList") getCourseList(val) {
        this.courseListData = val;
    }
    @Prop() readonly exam: any;
    @Prop() readonly examDetail: any;
    mounted() {
        this.userAvatar = JSON.parse(localStorage.getItem("user")).avatar;
    }
    updated() {
        this.$nextTick(function() {
            this.starValue = this.section.difficulty;
        });
    }

    handleSelect({ key, pageId }) {
        this.$emit("select", { key, pageId });
    }
    @Emit()
    handleExamRefresh() {}

    @Emit()
    handleJumpClick() {}

    @Emit()
    nextSectionClick() {}
}

//@ts-ignore
export { default as AiMain } from "./index.vue";
